import {
	Chart as ChartJS,
	ChartOptions,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { BaseLineGraphPropsType } from "../../../types/component.type";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
);

export const BaseLineGraph: React.FC<BaseLineGraphPropsType> = ({
	title,
	labels,
	datasets,
	width,
	height,
}) => {
	const data = { labels, datasets };

	const options: ChartOptions<"line"> = {
		responsive: true,
		maintainAspectRatio: false,
		elements: {
			point: {
				pointStyle: false,
			},
		},
		plugins: {
			legend: {
				position: "top" as const,
				display: false,
			},
			title: {
				display: true,
				text: title,
				align: "start" as const,
				color: "#000000",
				font: { family: "Poppins", weight: 400, size: 16 },
				padding: {
					bottom: 40,
				},
			},
		},
		scales: {
			x: {
				alignToPixels: true,
				offset: true,
				ticks: {
					font: { family: "Inter", weight: 500, size: 10 },
					padding: 10,
					callback: function (value) {
						// truncate label size and add ellipsis
						const lbl = this.getLabelForValue(value as number);
						if (typeof lbl === "string" && lbl.length > 5) {
							return `${lbl.substring(0, 5)}...`;
						}
						return lbl;
					},
				},
				grid: {
					drawTicks: false,
					display: false,
				},
				border: {
					color: "#000000",
					z: 2,
				},
			},
			y: {
				alignToPixels: true,
				beginAtZero: true,
				ticks: {
					font: { family: "Inter", weight: 500, size: 10 },
					callback: function (value) {
						// add percentage symbol for concerned axes
						const lbl = this.getLabelForValue(value as number);
						if (
							title === "Disbursed loan by Product" ||
							title === "Client Retention Rate"
						) {
							return `${lbl}%`;
						}
						return lbl;
					},
				},
				grid: {
					drawTicks: false,
				},
				border: {
					color: "#000000",
					z: 2,
				},
			},
		},
	};

	return <Line data={data} options={options} width={width} height={height} />;
};
